module.exports = __webpack_public_path__ + "static/img/banner-fabric-5.6226294.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/layout/banner/en/banner-fabric-5.jpg
// module id = 515
// module chunks = 63